import { useAuth } from "react-oidc-context";
import { useActiveOrg } from "common-fe";
import { useChangeNudgeSocket } from "common-fe/changeNudge";

// Card #3562 (docs/adr/0003): the announcer is a staff screen, so it holds the
// change-nudge socket for its show and ring. The socket's health and nudges land
// in the nudge store that useShowChangeCheck reads; this hook returns nothing and
// shows nothing. VITE_SCORE_WS_URL empty (local dev, an env without the
// WebSocket) means no socket: change checks at the normal rate, as before.
const WS_URL = import.meta.env.VITE_SCORE_WS_URL ?? "";

export function useStaffChangeNudge(showId, ring, { enabled = true } = {}) {
  const auth = useAuth();
  const { activeOrgId } = useActiveOrg();
  useChangeNudgeSocket({
    url: WS_URL,
    accessToken: auth.user?.access_token,
    orgId: activeOrgId,
    showId,
    ring,
    enabled,
  });
}

export default useStaffChangeNudge;
